import * as React from "react";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
const moment = require('moment')

export class Timeline extends React.Component {

    constructor(props) {
        super(props);
    }

    formatCal(time, showTimeAndDate = false){
        if(showTimeAndDate){
           return moment(time).utc().calendar()
        }else{
           return (time==null) ? null : `${moment(new Date(time)).utc().calendar(null,{
              lastDay : 'L',
              sameDay : 'L',
              nextDay : 'L',
              lastWeek : 'L',
              nextWeek : 'L',
              sameElse : 'L'
          })}`
        }
     }
     isDateBeforeToday(date) {
        let yesterday = moment().subtract(1, 'day').toDate();
        return moment(new Date(date)).isSameOrBefore(yesterday);
     }

    render() {
        let timelineItems = [];
        let {portfolio, orientation, items} = this.props;
        if(!this.props.items){
            let incubatorClosed = portfolio.incubatorEndTime ? portfolio.incubatorEndTime : portfolio.proposalDueTime;
            timelineItems = [
                {
                   title: 'Workshop Starts',
                   subtitle:this.formatCal(portfolio.beginTime, false),
                   time: portfolio.beginTime,
                   enabled: this.isDateBeforeToday(portfolio.beginTime)
                },
                {
                   title: `${portfolio.idBracket?'Submission':'Suggestion'} Period Ends`,
                   subtitle:this.formatCal(portfolio.suggestionEndTime, false),
                   time: portfolio.suggestionEndTime,
                   enabled: this.isDateBeforeToday(portfolio.suggestionEndTime)
                },
                {
                   title: 'Next Live Forum',
                   subtitle:this.formatCal(portfolio.askMeAnythingTime, false),
                   time: portfolio.askMeAnythingTime,
                   enabled: this.isDateBeforeToday(portfolio.askMeAnythingTime)
                },
                {
                   title: 'Overview Finalizes',
                   subtitle:this.formatCal(portfolio.descriptionFinalizedTime, false),
                   time: portfolio.descriptionFinalizedTime,
                   enabled:  this.isDateBeforeToday(portfolio.descriptionFinalizedTime)
                },
                {
                   title: 'Abstract Due',
                   subtitle:this.formatCal(portfolio.abstractDueTime, false),
                   time: portfolio.abstractDueTime,
                   enabled:  this.isDateBeforeToday(portfolio.abstractDueTime)
                },
                {
                   title: 'Proposal Due',
                   subtitle:this.formatCal(portfolio.proposalDueTime, false),
                   time: portfolio.proposalDueTime,
                   enabled:  this.isDateBeforeToday(portfolio.proposalDueTime)
                },
                {
                   title: portfolio.idBracket?'Finals Complete':'Workshop Ends',
                   subtitle:this.formatCal(incubatorClosed, false),
                   time: incubatorClosed,
                   enabled:  this.isDateBeforeToday(incubatorClosed)
                }
                ]
        }else{
            timelineItems = items;
        }
        if (orientation === 'vertical') {
            return (<Stepper activeStep={-1} orientation="vertical">
                {timelineItems.filter(cur => cur.subtitle != null).sort((a,b) => {return moment(a.time) - moment(b.time)}).map((cur) => (
                    <Step key={cur.title} active={cur.enabled == false}>
                        <StepLabel>
                        <div>
                           <div className={'timeline-item-title'}>
                              {cur.title}
                           </div>
                           <div className={'timeline-item-subtitle'}>
                              {cur.subtitle}
                           </div>
                        </div>
                           
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>);
        } else {
            let filteredItems = timelineItems.filter(cur => cur.subtitle != null).sort((a,b) => {return moment(a.time) - moment(b.time)});
            if(filteredItems.length > 4){
                filteredItems = filteredItems.filter(cur => cur.enabled == false).slice(0,4)
            }
            return (
                <Stepper alternativeLabel activeStep={-1} orientation={'horizontal'} nonLinear>
                    {filteredItems.map(cur => {
                        const labelProps = {};
                        labelProps.optional = <Typography style={{textAlign:'center', color:'gray', fontSize:'12px'}}>{cur.subtitle}</Typography>;
                        return (
                            <Step active={cur.enabled == false} key={cur.title}>
                                <StepLabel {...labelProps}>{cur.title}</StepLabel>
                            </Step>
                        )
                    })}
                </Stepper>
            );
        }

    }

};
